export enum TestIds {
  CompletedBy = 'CompletedBy',
  ImpactId = 'ImpactId',
  Likelihood = 'Likelihood',
  RatedItemId = 'RatedItemId',
  Rating = 'Rating',
  TestDate = 'TestDate',
}
